import { combineActions, handleActions } from 'redux-actions';
import { IAccountResponseError } from '../../account.data';
import { ROUTER_REQUEST } from '@ngrx/router-store';
import {
  AccountActionsEnum,
  PromptUnusualActivity,
  ResendUnusualLoginEmailError,
  ResendUnusualLoginEmailSuccess,
  VerifyUnusualLoginError,
  VerifyUnusualLoginSuccess,
} from '../actions';
import { Challenge } from '../models/sub-models';
import { LoginAttemptResult } from '../models';

export interface IState {
  challenge: Challenge;
  message: string;
  loginAttemptResult: LoginAttemptResult;
  error: IAccountResponseError;
}

export const initialState: IState = {
  challenge: null,
  message: null,
  error: null,
  loginAttemptResult: null,
};

const reducerFn = handleActions(
  {
    // clear the error when user navigates to a different route
    [ROUTER_REQUEST]: function (state: IState) {
      return {
        ...state,
        message: null,
        error: null,
        loginAttemptResult: null,
      };
    },
    [AccountActionsEnum.PROMPT_UNUSUAL_ACTIVITY]: function (
      state: IState,
      { payload }: PromptUnusualActivity
    ) {
      return {
        ...state,
        challenge: payload.challenge,
      };
    },
    [AccountActionsEnum.RESEND_UNUSUAL_LOGIN_EMAIL_SUCCESS]: function (
      state: IState,
      { payload }: ResendUnusualLoginEmailSuccess
    ) {
      return {
        ...state,
        message: payload.message,
        error: null,
      };
    },
    [AccountActionsEnum.VERIFY_UNUSUAL_LOGIN_SUCCESS]: function (
      state: IState,
      { payload }: VerifyUnusualLoginSuccess
    ) {
      return {
        ...state,
        loginAttemptResult: payload.loginAttemptResult,
      };
    },
    [combineActions(
      AccountActionsEnum.RESEND_UNUSUAL_LOGIN_EMAIL_ERROR,
      AccountActionsEnum.VERIFY_UNUSUAL_LOGIN_ERROR
    )]: function (
      state: IState,
      { payload }: ResendUnusualLoginEmailError | VerifyUnusualLoginError
    ) {
      return {
        ...state,
        error: {
          description: payload.message,
        },
      };
    },
  } as any,
  initialState
);

export function reducer(state: IState, action: any) {
  return reducerFn(state, action);
}
